var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrayUndefined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1289_31099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#97A0AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 13.375C13.8125 13.8672 13.4023 14.25 12.9375 14.25C12.4453 14.25 12.0625 13.8672 12.0625 13.375C12.0625 11.4609 13.6211 9.875 15.5625 9.875H16.4375C18.3516 9.875 19.9375 11.4609 19.9375 13.375V13.4844C19.9375 14.6875 19.3086 15.7812 18.3242 16.4375L17.1758 17.1758C16.9844 17.2852 16.875 17.5039 16.875 17.7227V17.75C16.875 18.2422 16.4648 18.625 16 18.625C15.5078 18.625 15.125 18.2422 15.125 17.75V17.7227C15.125 16.9023 15.5352 16.1367 16.2188 15.6992L17.3672 14.9609C17.8594 14.6328 18.1875 14.0859 18.1875 13.4844V13.375C18.1875 12.418 17.3945 11.625 16.4375 11.625H15.5625C14.5781 11.625 13.8125 12.418 13.8125 13.375ZM16 22.125C15.5898 22.125 15.2344 21.9336 15.043 21.5781C14.8516 21.25 14.8516 20.8398 15.043 20.4844C15.2344 20.1562 15.5898 19.9375 16 19.9375C16.3828 19.9375 16.7383 20.1562 16.9297 20.4844C17.1211 20.8398 17.1211 21.25 16.9297 21.5781C16.7383 21.9336 16.3828 22.125 16 22.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1289_31099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrayUndefined);
export default __webpack_public_path__ + "static/media/xray-undefined.a71623ba63b2e76adb3f820f4eddc8e5.svg";
export { ForwardRef as ReactComponent };